import { useStore } from 'vuex';

export function useNameFormatter() {
	const store = useStore();

	const getNameById = (id) => {
		if (!id) {
			return '';
		}
		return store.state.users.usersMap[id].sortName;
	};

	return {
		getNameById,
	};
}

export default useNameFormatter;
